import { ajax } from '../../../services/helper'
class ApiService {

    getAssetsData = (status,vendor,location_type,location_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assets/list?status="+status+"&vendor_id="+vendor+"&location_type="+location_type+"&location_id="+location_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getAssetById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assets/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getAssetGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    


    addAsset = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assets/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editAsset = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assets/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Assets/services/apiservices.js